import gql from 'graphql-tag'
import {
	main as mainFragment,
	kasse as kasseFragment,
	hardware as hardwareFragment,
	general as generalFragment,
	external as externalFragment
} from './fragments'

export const main = gql`
mutation updateCashRegister($id: ID!, $fields: CashRegisterInput!) {
	cashAssist {
		updateCashRegister(id: $id, fields: $fields) {
			id
			mod_ver
			...cashRegisterMain
		}
	}
}
${mainFragment}`

export const kasse = gql`
mutation updateCashRegister($id: ID!, $fields: CashRegisterInput!) {
	cashAssist {
	  updateCashRegister(id: $id, fields: $fields) {
	    id
	    mod_ver
	    ...cashRegisterKasse
	  }
	 }
}
${kasseFragment}`

export const hardware = gql`
mutation updateCashRegister($id: ID!, $fields: CashRegisterInput!) {
	cashAssist {
		updateCashRegister(id: $id, fields: $fields) {
			id
			mod_ver
			...cashRegisterHardware
		}
	}
}
${hardwareFragment}
`

export const tseIdCR = gql`
mutation updateCashRegisterTse($id: ID!, $fields: CashRegisterInput!) {
	cashAssist {
		updateCashRegister(id: $id, fields: $fields) {
			id
			mod_ver
			tseRemoteCashRegisterId
		}
	}
}
`

export const general = gql`
mutation updateCashRegister($id: ID!, $fields: CashRegisterInput!) {
	cashAssist {
		updateCashRegister(id: $id, fields: $fields) {
			id
			mod_ver
			...cashRegisterGeneral
		}
	}
}
${generalFragment}`

export const external = gql`
mutation updateCashRegister($id: ID!, $fields: CashRegisterInput!){
	cashAssist {
	  updateCashRegister(id: $id, fields: $fields){
		id
		mod_ver
		...cashRegisterExternal
	  }
	}
}
${externalFragment}`

export default {
	main,
	kasse,
	hardware,
	general,
	external,
	tseIdCR
}
